// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { AnalyticsPlugin } from 'analytics'
import analytics from '.'

interface SendinbluePluginConfig {
    client_key: string
}

const onBrowserAndSendinblueLoaded = () => {
    if (typeof window === 'undefined') {
        return false
    }

    if (typeof sendinblue === 'undefined') {
        console.error('Sendinblue is not loaded')
        return false
    }

    return true
}

export default function pluginExample(userConfig): AnalyticsPlugin {
    return {
        name: 'sendinblue',
        config: userConfig,
        initialize: ({ config }: { config: SendinbluePluginConfig }) => {
            if (typeof window === 'undefined') {
                return
            }

            if (window.sib) {
                return
            }

            if (!config.client_key) {
                console.error('Sendinblue client key is required')
                return
            }

            /* eslint-disable */
            ;(function () {
                window.sib = {
                    equeue: [],
                    client_key: config.client_key,
                }
                /* OPTIONAL: email for identify request*/
                // window.sib.email_id = 'example@domain.com';
                window.sendinblue = {}
                for (var j = ['track', 'identify', 'trackLink', 'page'], i = 0; i < j.length; i++) {
                    ;(function (k) {
                        window.sendinblue[k] = function () {
                            var arg = Array.prototype.slice.call(arguments)
                            ;(
                                window.sib[k] ||
                                function () {
                                    var t = {}
                                    t[k] = arg
                                    window.sib.equeue.push(t)
                                }
                            )(arg[0], arg[1], arg[2], arg[3])
                        }
                    })(j[i])
                }
                var n = document.createElement('script'),
                    i = document.getElementsByTagName('script')[0]
                ;(n.type = 'text/javascript'),
                    (n.id = 'sendinblue-js'),
                    (n.async = !0),
                    (n.src = 'https://sibautomation.com/sa.js?key=' + window.sib.client_key),
                    i.parentNode.insertBefore(n, i),
                    window.sendinblue.page()
            })()
            /* eslint-enable */
        },
        page: ({ payload }) => {
            if (!onBrowserAndSendinblueLoaded()) return

            sendinblue.page(payload.properties.title, {
                ma_title: payload.properties.title,
                ma_url: payload.properties.url,
                ma_path: payload.properties.path,
                ma_referrer: payload.properties.referrer,
            })
        },
        track: ({ payload }) => {
            // https://tracker-doc.sendinblue.com/docs/advanced-features#track-events

            if (!onBrowserAndSendinblueLoaded()) return

            const userProperties = {}
            const user = analytics.user()

            if (user?.traits?.email) {
                userProperties.email = user.traits.email
            } else if (payload?.properties?.email) {
                userProperties.email = payload.properties.email
            }

            sendinblue.track(payload.event, userProperties, {
                // id: 'a4123c72-c6f7-4d8e-b8cd-4abb8a807891', it's your own unique identifier of the event. If you pass an existing identifier, Sendinblue will update the existing data in your Marketing Automation database.
                data: payload.properties,
            })
        },
        identify: ({ payload }) => {
            // https://tracker-doc.sendinblue.com/docs/advanced-features#identify-users

            if (!onBrowserAndSendinblueLoaded()) return

            sendinblue.identify(payload.traits.email, {
                EMAIL: payload.traits.email,
                FIRSTNAME: payload.traits.first_name,
                USER_ID: payload.traits.id,
                EMAIL_VERIFIED: !!payload.traits.email_verified,
                PRE_ENROLLED: !!payload.traits?.pre_enrolled_items?.length,
                ENROLLED: !!payload.traits?.enrolled_items?.length,
                PRO: payload.traits.subscription_status === 'ACTIVE',
                LAST_SEEN: new Date().toISOString(),
            })
        },
        loaded: () => {
            // return boolean so analytics knows when it can send data to third-party

            if (typeof window === 'undefined') {
                return
            }

            return !!window && !!window.sendinblue
        },
    }
}
